import React from 'react';
import { Box } from '@mui/material';
import {
  Bone,
  FrameworkColumnsSkeleton,
  InsightsPanelSkeleton
} from '../../../../../../components/ui/DashboardSkeletons';
import { CARD_HEIGHT } from './AdminLearningLifecycleDashboard';
import { GAPS_PANEL_WIDTH } from './GapsRisksPanel';
import { MOBILE_SX, useIsMobileApp } from '../../../../../../mobile/mobileApp';

/**
 * The Learning Dashboard's frame while the org's details are still loading
 * right after login: the Learning Gaps panel on the left and the framework
 * columns on the right, sized like the real page. Without it the route briefly
 * showed the Organisation Settings placeholder and the old programs board.
 */
const AdminDashboardSkeleton: React.FC = () => {
  // The phone's dashboard is one column: the panel, then a single stage.
  const isMobileApp = useIsMobileApp();
  return (
    <Box
      sx={{
        // Same frame as AdminLearningLifecycleDashboard.
        height: 'calc(100vh - 86px - 50px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#0F0F0F',
        px: 3,
        pt: 0.5,
        [MOBILE_SX]: { height: 'auto', px: 0, pt: 0 }
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          pb: 3,
          display: 'flex',
          flexDirection: 'row',
          [MOBILE_SX]: { flexDirection: 'column', gap: '20px', pb: 0 }
        }}
      >
        <InsightsPanelSkeleton
          sx={{
            flex: `0 0 ${GAPS_PANEL_WIDTH}`,
            minWidth: 0,
            mr: '8px',
            [MOBILE_SX]: { flex: '0 0 auto', mr: 0 }
          }}
        />
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Bone height={40} />
          <Box sx={{ flex: 1, minHeight: 0, display: 'flex' }}>
            <FrameworkColumnsSkeleton cardHeight={CARD_HEIGHT} {...(isMobileApp ? { columns: 1, cards: 2 } : {})} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDashboardSkeleton;
